import { Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import { getBankVersementByMarchand, getVersementByMarchand } from "../services/merchentApi";
import TableContainerMin from "../../../../common/TableContainerMin";
import '../utils/style.css';
import '../utils/detail.css';
import DetailManageMobileMoney from "./detailManageMobileMonet";
import DetailManageMoney from "./detailManageMobileMonet";
const VersementByMarchand = ({id}) => {
  const [selectedBusiness, setSelectedBusiness] = useState(null);
const [searchTerm, setSearchTerm] = useState("");
 const [filterValues, setFilterValues] = useState(null);
const [mobileVersements, setMobileVersements] = useState([]);
const [bankVersements, setBankVersements] = useState([]);
 const [typeVersement, setTypeVersement] = useState("MOBILE");
 const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
const normalizeMobile = (item) => ({
  ...item,
  id: item.transactionReference,
  business: item.developerAccountName,
  amount: item.amount,
   merchant:item.merchantAccountName,
  currency: item.currency,
  account: item.paymentMethodName,
  phone: item.clientNumber,
  date: item.createdAt,
  status: item.status,
  type: "MOBILE",
});
   const normalizeBank = (item) => ({
  id: item.id,
  business: item.developerAccountName, 
  merchant:item.merchantAccountName,
  amount: item.realAmount,            
  currency: item.currency,        
  account: item.paymentMethodName,
  phone: item.maskedIban,
  date: item.createdAt,
  status: item.status,
  client:item.clientNumber,
  transactionReferenceBank:item.transactionReference,
  type: "BANK",
});
const currentVersements =
  typeVersement === "MOBILE"
    ? mobileVersements.map(normalizeMobile)
    : bankVersements.map(normalizeBank);

const filteredVersement = currentVersements?.filter((versement) => {
  let match = true;
  if (searchTerm) {
    const name = versement?.nameBank || "";
    match = name.toLowerCase().includes(searchTerm.toLowerCase());
  }
  if (filterValues?.maskedIban) {
    match = match && versement.maskedIban === filterValues.maskedIban;
  }
  if (filterValues?.maskedBicCode) {
    match = match && versement.maskedBicCode === filterValues.maskedBicCode;
  }
  if (filterValues?.status) {
    match = match && versement.status === filterValues.status;
  }
  return match;
});
const [loading, setLoading] = useState(false);
useEffect(() => {
  if (!id) {
    return;
  }
  const fetchData = async () => {
    setLoading(true); 
    try {
      if (typeVersement === "MOBILE") {
        const res = await getVersementByMarchand(id);
        const data = res?.data || res;
        setMobileVersements(Array.isArray(data) ? data : []);
      }

      if (typeVersement === "BANK") {
        const res = await getBankVersementByMarchand(id);
        const data = res?.data || res;
        setBankVersements(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.log("🔴 API ERROR:", error?.response?.data || error);
    } finally {
      setLoading(false); 
    }
  };

  fetchData();
}, [id, typeVersement]); 
 const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const mobileColumns = [
  {
    Header: "Business",
    accessor: "business",
  },
  {
    Header: "Montant",
    accessor: "amount",
    Cell: ({ row }) =>
      `${row.original.amount} ${row.original.currency}`,
  },
  {
    Header: "Compte",
    accessor: "account",
  },
  {
    Header: "Téléphone",
    accessor: "phone", 
  },
  {
    Header: "Date",
    accessor: "date",
    Cell: ({ value }) =>
      new Date(value).toLocaleDateString(),
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => renderStatusBadge(value),
  },
      {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div  className="consulter"
              onClick={(e) => {
          e.stopPropagation();
          setSelectedBusiness(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true); 
        }}>
             consulter
            </div>
          </div>
        );
      },
      filterable: false,
    },
];
const bankColumns = [
    { Header: "Business", accessor: "business" },
   {
    Header: "Montant disponible",
    accessor: "amount",
    Cell: ({ row }) =>
      `${row.original.amount} ${row.original.currency}`,
  },
    { Header: "Numéro de compte", accessor:"client" },
    {
      Header: "Date de paiement",
      accessor: "date",
      Cell: ({ value }) => new Date(value).toLocaleDateString(),
    },
   {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => renderStatusBadge(value),
  },
   {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div  className="consulter"
          onClick={(e) => {
          e.stopPropagation();
          setSelectedBusiness(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true); 
        }}>
             consulter
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ];
const columns =
typeVersement === "MOBILE" ? mobileColumns : bankColumns;
const renderStatusBadge = (status) => {
  let label = "Inconnu";
  let icon = "❓";
  const style = {
    backgroundColor: "#FFEFD5",
    color: "#000",
    padding: "1px 6px",
    borderRadius: "100px",
    fontWeight: 400,
    fontSize: "13px",
    fontStyle: "Medium",
    display: "inline-block"
  };

  if (status === "ACTIVE") {
    label = "Active";
    icon = "✓";
    style.backgroundColor = "#EBFFEA";
    style.color = "#349C32";
  } else if (status === "PENDING_APPROVAL") {
    label = "En attente";
    icon = "⌛";
    style.backgroundColor = "#F6F6F6";
    style.color = "#000000";
  }
  else if (status === "SUCCESS" ) {
    label = "Confirmé";
     icon = "✓";
    style.backgroundColor = "#EBFFEA";
     style.color = "#349C32";
  }
  else if (status === "PENDING" ) {
    label = "Encours";
     icon = "⌛";
    style.backgroundColor = "#f9ffeaff";
     style.color = "#f1c40f";
  }
else if (status === "REJECTED" ) {
    label = "Echec";
     icon = "❌";
    style.backgroundColor = "#FFF0F0";
     style.color = "#D41C1C";
  }
  return <span style={style}>{icon} {label}</span>;
};
return(
  <>
<div className="versement-toolbar mb-3"
  style={{maxWidth: "",margin: "0 auto",padding: "0 20px",gap: "10px",}}>
  <div style={{ width: "180px" }}>
   <Select
  value={typeVersement}
  onChange={(value) => {
    setTypeVersement(value);
    setCurrentPage(1);
  }}
  style={{ width: "100%" }}
  options={[
    { value: "MOBILE", label: "Mobile Money" },
    { value: "BANK", label: "Bank" },
  ]}
/>
  </div>
  <input
    type="text"
    placeholder="Recherche un versement..."
    className="form-control"
   style={{ width: "100%" }}
    onChange={(e) => setSearchTerm(e.target.value)}
    value={searchTerm}
  />
  <Button
    className="filtrer"
    style={{ display: "flex", alignItems: "center", gap: "8px" }}
  >
    <img src={filter} alt="Filtrer" style={{ width: "20px", height: "20px" }} />
    Filtrer
  </Button>
      </div>  
      <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        {loading ? (
     <div style={{ textAlign: "center", padding: "20px" }}>
    ⏳<Spin/>
  </div>
) : (
  <TableContainerMin
    columns={columns}
    data={filteredVersement}
    isGlobalFilter={false}
    customPageSize={10}
    className="custom-header-css"
    divClass="table-responsive"
    tableClass="table w-100 mb-0 no-column-borders"
    theadClass="custom-thead"
    SearchPlaceholder="Recherche..."
    // HeaderTable={HeaderTable}
  />
)}
       
  {filteredVersement && filteredVersement.length === 0 && !loading && (
     <div
        style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 0"
      }}
    >
   <div style={{ textAlign: "center", padding: "20px" }}>
    📭 Aucun versement trouvé
  </div>
</div>
        )}
      </CardBody>
    </Card>
  </Col>
</Row>
    
 <DetailManageMoney
  isOpen={isModalOpen}
  toggle={() => setIsModalOpen(false)}
  selectedBusiness={selectedBusiness}
/> 
  </>
);
}
export default VersementByMarchand;
